import React, {useState} from 'react'
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "react-bootstrap"
import StadisticCard from './StadisticCard';
import PropTypes from 'prop-types';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import List from '../../../../../Templates/List';
import ListPagination from '../../../../../Templates/List/ListPagination';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import { useGetListLastActions } from '../../../../../../hooks/services/sKPI/useOfGAP';
import GapActionCard from '../GapActionCard/GapActionCard';
import './style.css'
import { ScrollablePane, ScrollbarVisibility, Toggle } from '@fluentui/react';
import { useFilterActionComponentData, useSortActionComponentData } from '../../../../../../hooks/component/useOfTransversal';
import { useSelector } from 'react-redux';
import { isDateExpired, isDateOnTime, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import moment from 'moment';

function GapActionStadistic(props) {
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);

    const { _actions: actionList } = useSelector((state) => state.gapScope);

    //Parametros de entrada.
    const { 
        inputParam_GapAnalyzeId = null,
        inputParam_GapRevisionId = null,
        inputParam_GapElementId = null,
        inputParam_DataList = null,
        inputParam_FireGetLastActions = false,
        inputParam_SetFireGetLastActions = null
    } = props;

    const [selectedItem, setSelectedItem] = useState(null);
    const [fireOrder, setFireOrder] = useState(false);
    const [fireFilter, setFireFilter] = useState(false);
    
    const [tglShowMyActionsValue, setTglShowMyActionsValue] = useState(false);
    const [lastActionSort, setLastActionSort] = useState(true);
    
    const [actionFilteredList, setActionFilteredList] = useState(__OBJECT_STRUCTURE_GetList(10));
    const [numberOfItems, setNumberOfItems] = useState(actionFilteredList.pageSize);
    useGetListLastActions(inputParam_GapAnalyzeId, actionList, setActionFilteredList, setNumberOfItems, inputParam_FireGetLastActions, inputParam_SetFireGetLastActions);
    useSortActionComponentData(actionFilteredList, setActionFilteredList, lastActionSort, fireOrder, setFireOrder)
    useFilterActionComponentData(actionList, setActionFilteredList, (selectedItem !== null ? selectedItem.type : 'isTotal'), tglShowMyActionsValue, fireFilter, setFireFilter, currentAuth.token.userName)

    let totalItemsList = 0;
    let completed = 0;
    let commitedOnTime = 0;
    let committedOutTime = 0;

    if (actionList.data !== null) {
        totalItemsList = actionList.data.length;
        completed = actionList.data.filter(x => x.statusId === 4).length;
        commitedOnTime = actionList.data.filter(x => x.statusId === 2 && !isNullUndefinedOrEmpty(x.endDate) ? isDateOnTime(x.endDate) : false).length;
        committedOutTime = actionList.data.filter(x => (x.statusId === 2 || x.statusId === 3) && !isNullUndefinedOrEmpty(x.endDate) ? isDateExpired(x.endDate) : false).length;
    }

    const container = {
        display: "flex",
        justifyContent: "center",
        margin: "0"
    };

    const cards = [
        { class: "col", title: t('data-lang-lbl-totalactions'), type: "isTotal", amount: totalItemsList, icon: "Documentation", color: "#a1a1a1", display: true },
        { class: "col", title: t('data-lang-lbl-accomplishedactions'), type: "isAccomplished", amount: completed, icon: "DocumentApproval", color: "#7FD7A7", display: true },
        { class: "col", title: t('data-lang-lbl-committedactions'), type: "isCommitted", amount: commitedOnTime, icon: "SurveyQuestions", color: "#A1B8E1", display: true },
        { class: "col", title: t('data-lang-lbl-expiredactions'), type: "isExpired", amount: committedOutTime, icon: "FileBug", color: "#FF7F7F", display: true },
        { class: "col", title: lastActionSort ? t('data-lang-lbl-lastactions') : t('data-lang-lbl-firstactions'), type: "isCustom", amount: null, icon: lastActionSort ? "DoubleChevronDown" : "DoubleChevronUp", color: "#a1a1a1", display: true },
    ];

    const onShowMyActionsChange = (e, checked) => {
        setTglShowMyActionsValue(checked);
        setFireFilter(true);
    };

    return (
        <Card className='h-100'>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{ t('data-lang-boxname-actionstadistic') }</b>
                    <Toggle
                        checked={ tglShowMyActionsValue }
                        onChange={ onShowMyActionsChange }
                        role="checkbox"
                        onText={ t('data-lang-lbl-myactions') }
                        offText={ t('data-lang-lbl-allactions')}
                        styles={ {root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                    />
                </Card.Title>
            </Card.Header>
            <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                <div className='book-toolbar d-flex float-end'>
                </div>
            </Card.Footer>
            <Card.Body>
                <Row className="p-0 pb-2" style={ container }>
                    {
                        cards.map((card, index) => (
                            card.display &&
                            <div key={index} className={`${card.class} ${card.display ? "d-unset" : "d-none"}`} style={{padding: "0px", minWidth: "70px"}} >
                                <StadisticCard
                                    inputParam_Item={ card }
                                    inputParam_ArrayLength={ 4 }
                                    inputParam_Index={index}
                                    inputParam_SelectedItem={selectedItem}
                                    inputParam_SetterSelectedItem={setSelectedItem}
                                    inputParam_LastActionSort={lastActionSort}
                                    inputParam_SetterLastActionSort={setLastActionSort}
                                    inputParam_SetFireOrder={setFireOrder}
                                    inputParam_SetFireFilter={setFireFilter}
                                />
                            </div>
                        ))
                    }
                </Row>
                <Row className='pt-2 border-top'>
                    <Col id="listActionStatistic">
                        {
                            (actionFilteredList.data && actionFilteredList.data.length > 0) && 
                            <ScrollablePane
                                style={{ minHeight: "262px", maxHeight: "100%", height: "100%"}}
                                styles={{
                                    root: { position: "relative" },
                                    contentContainer:{overflowX: "hidden"}
                                }}
                                scrollbarVisibility={ScrollbarVisibility.auto}
                                scrollContainerFocus={true}
                            >
                                <Row>
                                    {
                                        actionFilteredList.data.map((item, index) =>
                                            <Col xl={12} key={index} className='border-bottom'>
                                                <GapActionCard
                                                    inputParam_EditMode={false}
                                                    inputParam_GapElementId={inputParam_GapElementId}
                                                    inputParam_ActionItem={item}
                                                    inputParam_ShowSeparatorStyle={false}
                                                    inputParam_ShowVariableName={true}
                                                    inputParam_ShowCause={true}
                                                    inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                                    inputParam_GapRevisionId={inputParam_GapRevisionId}
                                                    inputParam_Dflex_Buttons={true}
                                                />
                                            </Col>
                                        )
                                    }
                                </Row>
                            </ScrollablePane>
                        }
                        <NoDataLayer display={ actionFilteredList.data === null } />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

///Proptypes
GapActionStadistic.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevisionId: PropTypes.number,
    
    inputParam_DataList: PropTypes.array,
};

export default GapActionStadistic;

